// extracted by mini-css-extract-plugin
export default {"loaderContainer":"styles_loaderContainer__CaL-q","loader":"styles_loader__nUrec"};